import {useState} from 'react';
import {useNavigate} from 'react-router-dom';
import './style.css';
import Logo from 'assets/ActusIcone2025x1024.png';
import apibasic from 'services/apibasic';
import Footer from 'components/footer';
import NavbarVisitante from 'components/navbarvisitante';
import LoginModal from 'pages/login/modal';

function SolicitaRedefinirSenha() {

    const [email, setEmail] = useState('');
    const [sucesso, setSucesso] = useState('');
    const [msg, setMsg] = useState('');
    const [loading, setLoading] = useState(false);
    const [showLoginModal, setShowLoginModal] = useState(false);
    const navigate = useNavigate();

    function Login() {
        navigate('/login');
    }

    const openLoginModal = () => setShowLoginModal(true);
    const closeLoginModal = () => setShowLoginModal(false);

    function solicitaNovaSenha(e) {
        e.preventDefault();

        if (email === '') {
            alert('Digite seu email para solicitar uma nova senha');
            return false
        }

        setLoading(true);
        apibasic.post('v1/usuarios/solicitatrocasenha', {
            email: email,
            telefone: ''
        }).then(response => {
            if (response.status === 202) {
                setSucesso('X');
                setLoading(false);
            } else {
                setMsg(response.response.data.erro)
                setSucesso('E');
                setLoading(false);
            }
        })
            .catch(err => {
                setMsg(err.response.data.erro)
                setSucesso('E');
                setLoading(false);
            })

    }

    function FormSolicita() {
        return <div className="solicita-card shadow-lg animate__animated animate__fadeIn">
                <div className="text-center mb-4">
                    <img className="solicita-logo mb-3" src={Logo} alt="Actus" />
                    <h3 className="solicita-title mb-2">Redefinir senha</h3>
                    <p className="solicita-subtitle text-muted">
                        Você receberá um e-mail com as instruções para redefinir sua senha com segurança.
                    </p>
                </div>

                <form className="form-solicita-new" onSubmit={solicitaNovaSenha}>
                    <div className="input-group-custom mb-4">
                        <label htmlFor="emailInput">Seu E-mail</label>
                        <input 
                            type="email" 
                            id="emailInput"
                            onChange={(e) => setEmail(e.target.value)} 
                            className="form-control-custom" 
                            placeholder="exemplo@email.com"
                            required
                        />
                    </div>

                    <button 
                        type="submit"
                        className="w-100 btn-solicita-main py-3 mb-3" 
                        disabled={loading}
                    >
                        {loading ? (
                            <div className="d-flex align-items-center justify-content-center">
                                <span className="spinner-border spinner-border-sm text-light me-2" role="status"></span>
                                <span>Enviando...</span>
                            </div>
                        ) : (
                            <span>Solicitar nova senha</span>
                        )}
                    </button>

                    {sucesso === 'E' && (
                        <div className="alert alert-danger mt-3 py-2 text-center" role="alert">
                            <i className="fas fa-exclamation-circle me-2"></i>{msg}
                        </div>
                    )}

                    <div className="text-center mt-4 pt-2">
                        <span className="text-muted">Lembrou sua senha? </span>
                        <span className="link-login-direct" style={{cursor: 'pointer'}} onClick={() => Login()}>
                            Voltar ao Login
                        </span>
                    </div>
                </form>
              </div>
    }

    function formSucess() {
        return <div className="solicita-card shadow-lg animate__animated animate__fadeIn">
                <div className="text-center mb-4">
                    <div className="success-icon-wrapper mb-3">
                        <i className="fas fa-check-circle text-success fa-4x"></i>
                    </div>
                    <h4 className="solicita-title mb-3">Solicitação realizada!</h4>
                    <p className="solicita-subtitle text-muted mb-4">
                        Sua solicitação foi enviada. Por favor, verifique seu e-mail (inclusive a caixa de SPAM).
                    </p>
                </div>
                
                <div className="alert alert-info border-0 bg-light p-4 rounded-4" role="alert">
                    <p className="small mb-2 fw-bold text-dark">Ainda precisa de ajuda?</p>
                    <p className="small mb-0 text-muted">
                        Envie um e-mail para <span className="text-primary fw-bold">contato@opnet.com.br</span> ou WhatsApp <span className="text-primary fw-bold">19-35822048</span>.
                    </p>
                </div>

                <div className="text-center mt-5">
                    <button className="btn-solicita-main px-5" onClick={() => Login()}>
                        <i className="fas fa-arrow-left me-2"></i> Ir para Login
                    </button>
                </div>
            </div>
    }


    return (
        <div className="solicita-redefinir-page">
            <NavbarVisitante login={openLoginModal} />
            
            <div className="solicita-main-content py-5">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-12 col-md-10 col-lg-7 col-xl-6">
                            { (sucesso === '' || sucesso === 'E') ? FormSolicita() : formSucess() }
                        </div>
                    </div>
                </div>
            </div>

            <LoginModal isOpen={showLoginModal} onRequestClose={closeLoginModal} />
            <Footer />
        </div>
    );
}

export default SolicitaRedefinirSenha;